import React, { useState } from 'react';
import { RiHeart3Fill, RiHeart3Line } from 'react-icons/ri';
import styles from './StoryVerdict.module.css';

/* Story Time ratings: one tap, asked twice (after episode 1, after the last episode). No stars: three honest words, and if it was not a hit,
   one more optional tap on what was off. `send(verdict, reasons)` posts it; the card thanks them and gets out of the way. */
const VERDICTS = [{ id: 'loved', label: 'Loved it' }, { id: 'fine', label: 'It was fine' }, { id: 'no', label: 'Not for me' }];
const REASONS = [{ id: 'story', label: 'The story' }, { id: 'voices', label: 'The voices' }, { id: 'music', label: 'The music' }, { id: 'sound', label: 'The sound' }, { id: 'pacing', label: 'The pacing' }];

export default function StoryVerdict({ moment, send, onDone }) {
  const [verdict, setVerdict] = useState('');
  const [reasons, setReasons] = useState([]);
  const [done, setDone] = useState(false);

  const pick = (v) => { setVerdict(v); send(v, []); if (v === 'loved') { setDone(true); if (onDone) setTimeout(onDone, 2200); } };
  const toggle = (r) => setReasons((cur) => (cur.includes(r) ? cur.filter((x) => x !== r) : [...cur, r]));
  const finish = () => { if (reasons.length) send(verdict, reasons); setDone(true); if (onDone) setTimeout(onDone, 1800); };

  if (done) return <div className={styles.card} role="status"><p className={styles.thanks}>{verdict === 'loved' ? <><RiHeart3Fill className={styles.heartOn} aria-hidden /> Glad you loved it.</> : 'Thank you. That helps us make the next one better.'}</p></div>;
  return (
    <div className={styles.card}>
      <p className={styles.ask}>{moment === 'end' ? 'That was the whole season. How was it?' : 'How was episode one?'}</p>
      <div className={styles.row} role="radiogroup" aria-label="Your verdict">
        {VERDICTS.map((v) => (
          <button key={v.id} type="button" role="radio" aria-checked={verdict === v.id} className={`${styles.verdict} ${verdict === v.id ? styles.verdictOn : ''} ${v.id === 'loved' ? styles.love : ''}`} onClick={() => pick(v.id)}>
            {v.id === 'loved' && (verdict === 'loved' ? <RiHeart3Fill aria-hidden /> : <RiHeart3Line aria-hidden />)} {v.label}
          </button>
        ))}
      </div>
      {verdict && verdict !== 'loved' && (
        <div className={styles.more}>
          <p className={styles.askSmall}>What was off? Tap any, or skip.</p>
          <div className={styles.row}>
            {REASONS.map((r) => <button key={r.id} type="button" role="checkbox" aria-checked={reasons.includes(r.id)} className={`${styles.chip} ${reasons.includes(r.id) ? styles.chipOn : ''}`} onClick={() => toggle(r.id)}>{r.label}</button>)}
          </div>
          <button type="button" className={styles.doneBtn} onClick={finish}>{reasons.length ? 'Send' : 'Skip'}</button>
        </div>
      )}
    </div>
  );
}
